<template>
  <div class="HowItWorks">
    <div class="artwork">
      <BaseIcon :name="iconName" />
    </div>
    <div class="leading">
      <p class="title">{{ title }}</p>
      <p class="description">{{ description }}</p>
    </div>
    <div class="content">
      <p class="steps-title">Como funciona</p>
      <ul class="steps">
        <li v-for="(step, index) in steps" :key="index" class="step">
          <span class="bullet">{{ index + 1 }}</span>
          <p class="text">{{ step }}</p>
        </li>
      </ul>
    </div>

    <div class="footer">
      <Button @click="onContinue">Continuar</Button>
    </div>
  </div>
</template>

<script>
import BaseIcon from '~/aasgard/components/base/BaseIcon.vue'
import Button from '~/aasgard/components/buttons/Button.vue'

export default {
  name: 'HowItWorks',
  components: {
    BaseIcon,
    Button,
  },
  props: {
    iconName: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    steps: {
      type: Array,
      required: true,
      validator: (value) => value.every((item) => typeof item === 'string'),
    },
  },
  emits: ['continue'],
  methods: {
    onContinue() {
      this.$emit('continue')
    },
  },
}
</script>

<style lang="scss">
.HowItWorks {
  display: flex;
  flex-direction: column;
  gap: 24px;

  & > .artwork {
    width: 64px;
    height: 64px;
    background-color: $color-brand-primary;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;

    & > svg {
      @include setSVGMonoColor($color-white-high);
    }
  }

  & > .leading {
    text-align: center;
    & > .title {
      @include headline-5;
      margin-bottom: 8px;
    }
    & > .description {
      @include body-1;
      color: $color-black-medium;
      margin: 0;
    }
  }

  & > .content {
    & > .steps-title {
      padding: 16px 0;
      @include subtitle-1;
      margin: 0;
    }

    & > .steps {
      list-style: none;
      background-color: $color-neutral-light;
      padding: 0 16px;
      border-radius: 12px;

      & > .step {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 16px 0;
        border-bottom: solid 1px $color-neutral-dark;

        &:last-child {
          border-bottom: none;
        }

        & > .bullet {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background-color: $color-neutral-dark;
          display: flex;
          align-items: center;
          justify-content: center;
          @include overline;
          color: $color-black-high;
          flex-shrink: 0;
        }

        & > .text {
          @include body-2;
          margin: 0;
          color: $color-black-medium;
        }
      }
    }
  }

  & > .footer {
    width: 100%;
    padding: 16px;
    position: sticky;
    z-index: 1;
    bottom: 0;
    left: 0;
    background-color: $color-white-high;
    display: flex;
    flex-direction: column;

    & > .Button.submit {
      width: 100%;
    }
  }
}
</style>
